export default "mutation insertFeedback ($feedback: FeedbackInput!) {\n  insertFeedback (feedback: $feedback)\n}";